import useSWR from "swr";

import useAuth from "hooks/useAuth";

import { ApiError, Policy } from "types/api";

export const useUserPolicies = () => {
  const { organizationId } = useAuth();
  const { user } = useAuth();

  const { data, error, mutate } = useSWR<Policy[], ApiError>(
    organizationId && user ? `organization/${organizationId}/user/policy` : null
  );

  return {
    policies: data,
    policiesError: error,
    isPoliciesLoading: !data && !error,
    mutatePolicies: mutate,
  };
};
